import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { ITicketDetails } from '../interfaces/interface';

export function getTicketsTableData(tableData: any[]) {
  const table: any[] = [];
  tableData.forEach((ticketDetails: any) => {
    table.push({
      asset: {
        assetCode: ticketDetails.ticketAssets[0]?.assets?.assetCode || 'N/A',
        name: ticketDetails.ticketAssets[0]?.assets?.name || 'N/A',
      },
      ticket: {
        ticketNumber: ticketDetails?.ticketNumber || 'N/A',
        ticketId: ticketDetails?.id || ticketDetails?.ticketAssets[0]?.ticketId,
        fileUrl: ticketDetails.fileUrl,
        title: ticketDetails?.title || 'N/A',
        isExternalTicket: `${ticketDetails?.isExternalUser ? true : false}`,
        user: {
          firstName: ticketDetails?.users?.firstName || 'N/A',
          lastName: ticketDetails?.users?.lastName || 'N/A',
          email:
            ticketDetails?.users?.email ||
            ticketDetails?.externalUserEmail ||
            'N/A',
          externalUserName: ticketDetails?.externalUserName || 'N/A',
        },
        assignee: {
          firstName: ticketDetails?.assignee?.firstName || 'N/A',
          lastName: ticketDetails?.assignee?.lastName || 'N/A',
          email: ticketDetails?.assignee?.email || 'N/A',
        },
        createdAt: ticketDetails?.createdAt || 'N/A',
        status: ticketDetails?.status || 'N/A',
        isExternalUser: ticketDetails?.isExternalUser || false,
      },
      ticketOrder: {
        ticketOrder: ticketDetails.ticket_order
      },
      ticketPriorities: {
        ticketPriority: ticketDetails?.ticket_priorities?.name
      }
    });
  });
  return table;
}

export function getAssetTeamTicketsData(ticketDetails: any[]) {


  const tableDetails: any[] = []
  ticketDetails.forEach((ticketDetails: any) => {
    tableDetails.push({
      ticketId: ticketDetails?.id || ticketDetails?.ticketAssets[0]?.ticketId,
      TicketNo: ticketDetails?.ticketNumber || 'N/A',
      AssetName: ticketDetails.assetTypes?.name || 'N/A',
      Priority: ticketDetails?.ticket_priorities?.name || 'N/A',
      status: ticketDetails?.status || 'N/A',
      UserName: (ticketDetails?.users?.firstName || 'N/A') + ' ' + (ticketDetails?.users?.lastName || ' '),
      UserEmail:
        ticketDetails?.users?.email ||
        ticketDetails?.externalUserEmail ||
        'N/A',
      isExternalTicket: ticketDetails?.isExternalUser || false,
      externalUserName: ticketDetails?.externalUserName || 'N/A',
      AssigneeName: (ticketDetails?.assignee?.firstName || 'N/A') + ' ' + (ticketDetails?.assignee?.lastName || ' '),
      AssigneEmail: ticketDetails?.assignee?.email || 'N/A',
      description: ticketDetails?.description || 'N/A',
      Date: ticketDetails?.createdAt.split('T')[0] || 'N/A',
      Day: ticketDetails?.day,
      ticketSubStatus: ticketDetails?.ticketSubStatus
    })

  })
  return tableDetails;
}
export function getApprovalData(ticketDetails: any) {
  const tableDetails: any[] = []
  ticketDetails.forEach((ticketDetails: any) => {
    tableDetails.push({
      approvalId: ticketDetails?.id || ticketDetails?.approvers[0]?.approvalId,
      date: ticketDetails?.createdAt,
      ticketId: ticketDetails?.ticketId,
      ticketNo: ticketDetails?.ticketNumber || 'N/A',
      status: ticketDetails?.finalStatus,
      ticketStatus: ticketDetails?.ticketStatus,
      approvers: ticketDetails?.approvers[0].firstName || 'Name',
      createdBy: ticketDetails?.createdByFirstName + ' ' + ticketDetails?.createdByLastName,
      createdByEmail: ticketDetails?.createdByEmail,
      description: ticketDetails?.description,
      assignedTo: ticketDetails?.assignedToFirstName + ' ' + ticketDetails?.assignedToLastName,
      assignedToEmail: ticketDetails?.assignedToEmail
    })
  })
  return tableDetails
}
export function getWorkspaceData(ticketDetails: any) {
  const tableDetails: any[] = []
  ticketDetails.forEach((ticketDetails: any) => {
    tableDetails.push({
      workspaceId: ticketDetails?.id,
      workspaceName: ticketDetails?.name,
      plan: ticketDetails?.plan[0]?.plan?.name || 'N/A',
      startDate: ticketDetails?.plan[0]?.activeFrom,
      endDate: ticketDetails?.plan[0]?.activeTo
    })
  })
  return tableDetails
}
export function getAssetsTableData(tableData: any[]) {
  const table: any[] = [];
  tableData.forEach((assetDetails: any) => {
    table.push({
      asset: {
        asset_type: {
          assetCode: assetDetails.assetCode ? assetDetails.assetCode : 'N/A',
          name: assetDetails.name ? assetDetails.name : 'N/A',
        },
        name: assetDetails.name ? assetDetails.name : 'N/A',
      },
      ticket: {
        user: {
          firstName: '',
          lastName: '',
          email: '',
        },
        updatedAt: assetDetails.updatedAt
          ? assetDetails.updatedAt
          : assetDetails.createdAt,
      },
      status: assetDetails.status,
    });
  });
  return table;
}

export function getAssetsTableDataInventory(tableData: any[]) {

  const table: any[] = [];
  tableData.forEach((assetDetails: any) => {
    table.push({
      asset: {
        asset_type: {
          assetCode: assetDetails.assetCode ? assetDetails.assetCode : 'N/A',
          name: assetDetails.name ? assetDetails.name : 'N/A',
        },
        assetCode: assetDetails.assetCode ? assetDetails.assetCode : 'N/A',
        name: assetDetails ? assetDetails.name : 'N/A',
        loan_status: assetDetails.status ? assetDetails.status : 'N/A',
        loanee: 'N/A',
        asset_id: assetDetails.id,
        location: assetDetails.properties.find((prop: any) => prop.name === 'location')?.value,
        purchaseDate: assetDetails?.purchaseDate,
        createdAt: assetDetails.createdAt || 'N/A',
      },
      ticket: {
        user: {
          firstName: assetDetails.asset_allocations[0] && assetDetails.asset_allocations[0].user ? assetDetails.asset_allocations[0].user.firstName : 'N/A',
          lastName: assetDetails.asset_allocations[0] && assetDetails.asset_allocations[0].user ? assetDetails.asset_allocations[0].user.lastName : '',
          email: assetDetails.asset_allocations[0] && assetDetails.asset_allocations[0].user ? assetDetails.asset_allocations[0].user.email : 'N/A'
        },
        updatedAt: assetDetails.updatedAt
          ? assetDetails.updatedAt
          : assetDetails.createdAt,
      },
    });
  });
  return table;
}

export function getWorkspaceTableData(tableData: any[]) {
  const table: any[] = [];

  tableData.forEach((workspaceDetails: any) => {

    table.push({
      workspace: {
        name: workspaceDetails.name || 'N/A', // Workspace name
        status: workspaceDetails.isActive ? 'Active' : 'Inactive', // Workspace status based on isActive field
        expiresOn: workspaceDetails.plan[0].activeFrom || 'N/A', // Expiration date
        workspace_id: workspaceDetails.id, // Workspace ID
        codeTemplate: workspaceDetails.codeTemplate.join(', ') || 'N/A', // Code templates as a comma-separated string
        acronyms: workspaceDetails.acronyms.join(', ') || 'N/A', // Acronyms as a comma-separated string
      },
      creator: {
        firstName: workspaceDetails.createdByUser?.firstName || 'N/A', // Creator first name
        lastName: workspaceDetails.createdByUser?.lastName || 'N/A', // Creator last name
        email: workspaceDetails.createdByUser?.email || 'N/A', // Creator email
      },
      createdAt: workspaceDetails.createdAt ? new Date(workspaceDetails.createdAt).toLocaleString() : 'N/A', // Created date formatted
      projects: workspaceDetails.projects.map((project: any) => project.name).join(', ') || 'N/A', // Projects in the workspace as a comma-separated string
    });
  });
  return table;
}


export function getAssetCounts(dataSource: any) {
  const data = dataSource.map(
    (assetType: {
      assetName: string;
      totalAssetCount: string;
      assetDetails: { count: number }[];
    }) => {
      return {
        totalAssets: {
          assetType: assetType.assetName,
          count: assetType.totalAssetCount,
        },
        assignedAssets: assetType.assetDetails[0].count,
        unassignedAssets: assetType.assetDetails[1].count,
        outForRepair: assetType.assetDetails[2].count,
        inHouseRepair: assetType.assetDetails[3].count
      };
    }
  );

  return data;
}

export function getTicketDetails(ticket: any) {
  const ticketDetails = {
    assetDetails: {
      assetName: ticket.ticketAssets[0]?.assets?.name || 'N/A',
      assetId: ticket.ticketAssets[0]?.assets?.assetCode || 'N/A',
    },
    issueDescription: {
      description: ticket.description || 'N/A',
      title: ticket.title || 'N/A',
      approvalStatus: ticket.approvalStatus,
    },
    assignedTo: {
      id: ticket.assignee?.id,
      name: `${ticket.assignee?.firstName} ${ticket.assignee?.lastName}`
    },
    ticketRaisedBy: ticket.users || null,
    ticketClosureFile: ticket.ticketClosureFile || null,
    ticketClosedBy: ticket.ticketClosedBy ? {
      id: ticket.ticketClosedBy.id,
      firstName: ticket.ticketClosedBy.firstName,
      lastName: ticket.ticketClosedBy.lastName
    } : null,
    ticketDetails: {
      isExternalUser: ticket.isExternalUser || false,
      externalUserEmail: ticket.externalUserEmail,
      ticketNo: `#${ticket.isExternalUser ? 'Ext - ' : ''}${ticket.ticketNumber || 'N/A'
        }`,
      ticketId: `${ticket.ticketAssets[0]?.ticketId || 'N/A'}`,
      files: ticket.ticket_files || [],
      status: ticket.status || 'N/A',
      ticketSubStatus: ticket.ticketSubStatus || 'N/A',
      assignedTo: ticket?.assignee?.id || '',
      comments: ticket.ticketComments,
      type: ticket.type,
      reporter: `${ticket.users?.firstName && ticket.users?.lastName
        ? ticket.users?.firstName + ' ' + ticket.users?.lastName
        : ticket.externalUserName || 'N/A'
        }`,
      designation: ticket.users?.employeeDesignation.attributeValue || 'N/A',
      userId: ticket.userId || null,
      userLocation: ticket.location || null,
      userEmail: ticket.users?.email || null,
      reporterEmployeeId: ticket.users?.employeeId || 'N/A',
      ticketRaisedDate: new DatePipe('en-us').transform(
        ticket.createdAt,
        'dd/MM/yyyy'
      ),
      ticketRaisedTime: new DatePipe('en-us').transform(ticket.createdAt, 'hh:mm a'),
      workspaceId: ticket?.workspaceId
    },
    assetTypes: {
      name: ticket.assetTypes?.name || null,
      assetTypeCode: ticket.assetTypes?.assetTypeCode || null,
      id: ticket.assetTypes?.id || null,
    },
    newAsset: ticket.newAsset ? { ...ticket.newAsset } : null,
    ticketSubcategories: [...ticket?.ticket_sub_categories],
    assetId: ticket.ticketAssets[0]?.assetId,
    ticketPriority: {
      priorityId: ticket?.ticket_priorities?.id,
      priorityName: ticket?.ticket_priorities?.name,
      timeStamp: ticket?.ticket_priorities?.durationInHours,
      priorityChangeCount: ticket?.priorityChangeCount
    },
    currentRecord: ticket?.ticketAssets[0]?.assets?.asset_allocations[0]?.currentRecord
  };

  return ticketDetails as ITicketDetails;
}

export function getAddAssetData(addAssetData: any) {
  const data = {
    assetCode: addAssetData.assetCode || null,
    type: addAssetData.type || null,
    modelName: addAssetData.modelName || null,
    location: addAssetData.location || null,
    purchaseDate: addAssetData.purchaseDate || null,
    vendorName: addAssetData.vendorName || null,
    warranty: addAssetData.warranty || null,
    ram: addAssetData.laptopFields?.ram || null || addAssetData.mobileFields?.ram,
    diskSpace: addAssetData.laptopFields?.diskSpace || null,
    processor: addAssetData.laptopFields?.processor || null,
    clientId: addAssetData.clientId || null,
    projectId: addAssetData.projectId || null,
    serialNo:
      addAssetData.laptopFields?.serialNo ||
      addAssetData.headphoneFields?.serialNo ||
      addAssetData.mobileFields?.serialNo ||
      addAssetData.monitorFields?.serialNo ||
      null,
    operatingSystem: addAssetData.laptopFields?.operatingSystem || null,
    screenSize:
      addAssetData.laptopFields?.screenSize ||
      addAssetData.monitorFields?.screenSize ||
      null,
    endPointSecurityId: addAssetData.laptopFields?.endPointSecurityId || null,
    screenSizeUnit:
      addAssetData.laptopFields?.screenSizeUnit ||
      addAssetData.monitorFields?.screenSizeUnit ||
      null,
    diskSpaceUnit: addAssetData.laptopFields?.diskSpaceUnit || null,
    ramUnit: addAssetData.laptopFields?.ramUnit || null || addAssetData.mobileFields?.ramUnit,
  };

  return data;
}

export const closeDropdown = new Subject<boolean>();

export const paginationChange = new Subject<boolean>();

export function convertToTitleCase(data: string) {
  return data
    .toLowerCase()
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function convertToCapitalCase(data: string) {
  return data
    .toUpperCase()
    .replace(" ", "-")
}
